import { escaparHtml } from '@plataforma/utils';

const ICONOS_RED = {
  whatsapp:
    '<path d="M17.5 14.4c-.3-.2-1.8-.9-2.1-1s-.5-.2-.7.2-.8 1-1 1.2-.4.2-.7.1a8.3 8.3 0 0 1-2.4-1.5 9 9 0 0 1-1.7-2.1c-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.5s0-.4 0-.6-.7-1.7-1-2.3c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4s-1.2 1.2-1.2 2.9 1.3 3.4 1.4 3.6 2.5 3.8 6 5.3c.8.3 1.5.5 2 .6.9.3 1.7.2 2.3.1.7-.1 1.8-.8 2.1-1.5.3-.7.3-1.3.2-1.5-.1-.1-.3-.2-.6-.4z"/><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2z"/>',
  instagram:
    '<rect width="18" height="18" x="3" y="3" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1"/>',
  facebook: '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3.5l.5-4h-4V7a1 1 0 0 1 1-1h3z"/>',
  tiktok:
    '<path d="M14 3v10.2a4.8 4.8 0 1 1-4-4.7v3.1a1.8 1.8 0 1 0 1 1.6V3h3a5.8 5.8 0 0 0 5 5.7v3.1A8.8 8.8 0 0 1 14 9.9"/>',
  youtube:
    '<path d="M22 8.5a3 3 0 0 0-2.1-2.1C18 6 12 6 12 6s-6 0-7.9.4A3 3 0 0 0 2 8.5 31 31 0 0 0 2 15.5a3 3 0 0 0 2.1 2.1C6 18 12 18 12 18s6 0 7.9-.4a3 3 0 0 0 2.1-2.1 31 31 0 0 0 0-7z"/><path d="m10 15 5-3-5-3z"/>',
};

export function iconoRedSocial(nombre, { clase = '', label = '' } = {}) {
  const clave = String(nombre ?? '').toLowerCase();
  const contenido = ICONOS_RED[clave];
  if (!contenido) return '';

  const claseAttr = clase ? ` class="${escaparHtml(clase)}"` : '';
  const aria = label ? `role="img" aria-label="${escaparHtml(label)}"` : 'aria-hidden="true"';

  return `<svg${claseAttr} ${aria} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${contenido}</svg>`;
}
